import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Users, BarChart3, MessageCircle, Share2, Wallet, Settings, LogOut, X } from 'lucide-react';

const ITEMS = [
  { label: 'العملاء', icon: Users, path: '/venue-owner-dashboard/customers', testId: 'more-sheet-customers' },
  { label: 'التقارير', icon: BarChart3, path: '/venue-owner-dashboard/reports', testId: 'more-sheet-reports' },
  { label: 'الإشعارات/واتساب', icon: MessageCircle, path: '/venue-owner-dashboard/notifications', testId: 'more-sheet-notifications' },
  { label: 'صفحة الملعب العامة', icon: Share2, path: '/venue-owner-dashboard/public-page', testId: 'more-sheet-public-page' },
  { label: 'الاشتراك', icon: Wallet, path: '/venue-owner-dashboard/subscription', testId: 'more-sheet-subscription' },
  { label: 'الإعدادات', icon: Settings, path: '/venue-owner-dashboard/settings', testId: 'more-sheet-settings' },
];

export default function VenueOwnerMobileMoreSheet({ onClose, onLogout }) {
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = ''; };
  }, []);

  const navigate = useNavigate();
  const go = (path) => { onClose(); navigate(path); };

  return (
    <div className="fixed inset-0 z-[60] flex flex-col justify-end bg-slate-900/40 backdrop-blur-[2px] lg:hidden" data-testid="venue-owner-more-sheet-container" onClick={onClose}>
      <div
        className="relative max-h-[85vh] animate-sheet-up space-y-4 overflow-y-auto rounded-t-[28px] bg-white p-5 shadow-[0_-12px_40px_rgba(15,23,42,0.18)]"
        style={{ paddingBottom: 'calc(env(safe-area-inset-bottom, 16px) + 20px)' }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="mx-auto -mt-1 mb-1 h-1.5 w-12 rounded-full bg-slate-200" />
        <div className="flex items-center justify-between px-1 pb-1">
          <h4 className="text-base font-bold text-slate-900">المزيد</h4>
          <button onClick={onClose} data-testid="venue-owner-more-sheet-close-btn" className="rounded-full p-1.5 text-slate-400 hover:bg-slate-100 hover:text-slate-700">
            <X className="h-5 w-5" />
          </button>
        </div>

        <div className="space-y-2" data-testid="venue-owner-more-sheet-list">
          {ITEMS.map((item) => (
            <button
              key={item.testId}
              onClick={() => go(item.path)}
              data-testid={item.testId}
              className="flex w-full items-center gap-3 rounded-2xl border border-slate-100 bg-white px-4 py-3.5 text-sm font-semibold text-slate-700 transition-colors active:scale-[0.98] hover:border-orange-200 hover:bg-orange-50/60"
            >
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-orange-50">
                <item.icon className="h-4.5 w-4.5 text-orange-600" />
              </span>
              {item.label}
            </button>
          ))}
        </div>

        <button
          onClick={() => { onClose(); onLogout(); }}
          data-testid="venue-owner-more-sheet-logout"
          className="flex w-full items-center gap-3 rounded-2xl border border-red-100 bg-red-50/60 px-4 py-3.5 text-sm font-semibold text-red-600 transition-colors active:scale-[0.98] hover:bg-red-50"
        >
          <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-red-100/70">
            <LogOut className="h-4.5 w-4.5" />
          </span>
          تسجيل الخروج
        </button>
      </div>
      <style>{`
        @keyframes sheet-up { from { opacity: 0; transform: translateY(24px); } to { opacity: 1; transform: translateY(0); } }
        .animate-sheet-up { animation: sheet-up 0.22s ease-out; }
      `}</style>
    </div>
  );
}
